import { debounce } from 'lodash'

export const renderTooltip = (e: Event, msg: string, shouldRender = true) => {
  if (!shouldRender) return
  const target = e.target as HTMLElement
  const offset = 8
  let top = true

  const screenHeight = window.innerHeight
  const screenWidth = document.body.clientWidth
  const targetPos = target.getBoundingClientRect()

  // create tooltip element & get position
  const [tooltip, caret] = createTooltip(msg)
  document.body.appendChild(tooltip)

  const tooltipPos = tooltip.getBoundingClientRect()

  // calculate position
  if (targetPos.top > screenHeight - targetPos.bottom) {
    // tooltip on top
    tooltip.style.top = `${targetPos.top - offset - tooltipPos.height}px`
    caret.style.bottom = '0px'
    caret.style.transform = 'translateY(100%)'
  } else {
    // tooltip on bottom
    top = false
    caret.style.transform = 'translateY(-100%) rotate(180deg)'
    caret.style.top = '0px'
    tooltip.style.top = `${targetPos.top + targetPos.height + offset}px`
  }

  const tooltipCenter = targetPos.left + targetPos.width / 2 - tooltipPos.width / 2;

  // Center if tooltip fits in the screen
  if (tooltipCenter >= 0 && (tooltipCenter + tooltipPos.width) <= screenWidth) {
    tooltip.style.left = `${tooltipCenter}px`;
    caret.style.left = '50%';
    caret.style.right = '';
    caret.style.transform = caret.style.transform + ` translateX(${top ? '-' : ''}50%)`
  } else if (targetPos.left > screenWidth - targetPos.right) {
    // tooltip floats left
    tooltip.style.right = `${screenWidth - targetPos.right}px`
    caret.style.right =
      Math.min(targetPos.width / 2, tooltipPos.width - offset * 2) + 'px'
    caret.style.transform =
      caret.style.transform + ` translateX(${top ? '' : '-'}50%)`
  } else {
    // tooltip floats right
    tooltip.style.left = `${targetPos.left}px`
    caret.style.left =
      Math.min(targetPos.width / 2, tooltipPos.width - offset * 2) + 'px'
    caret.style.transform =
      caret.style.transform + ` translateX(${top ? '-' : ''}50%)`
  }

  const mouseMoveHandler = debounce(
    e => {
      const x = e.clientX
      const y = e.clientY
      if (
        x < targetPos.left - 3 ||
        x > targetPos.right + 3 ||
        y < targetPos.top - 3 ||
        y > targetPos.bottom + 3
      ) {
        removeTooltipHandler()
      }
    },
    50,
    { leading: true, trailing: true }
  )

  const removeTooltipHandler = () => {
    tooltip.remove()
    target.removeEventListener('mouseleave', removeTooltipHandler)
    window?.removeEventListener('scroll', removeTooltipHandler)
    window?.removeEventListener('click', removeTooltipHandler)
    window?.removeEventListener('mousemove', mouseMoveHandler)
  }

  window.addEventListener('mousemove', mouseMoveHandler)
  window.addEventListener('scroll', removeTooltipHandler)
  window.addEventListener('click', removeTooltipHandler)
  target.addEventListener('mouseleave', removeTooltipHandler)
}

const createTooltip = msg => {
  const tooltip = document.createElement('div')
  const caret = document.createElement('div')
  caret.classList.add('caret')
  tooltip.classList.add('tooltip')
  tooltip.innerHTML = msg
  tooltip.appendChild(caret)
  return [tooltip, caret]
}
